/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/tile/custom-elements';

import { defineCustomElement as defineOsdsTile } from '@ovhcloud/ods-stencil/components/tile/custom-elements/osds-tile.js';


export const OsdsTile = /*@__PURE__*/ defineContainer<JSX.OsdsTile>('osds-tile', defineOsdsTile, [
  'hasFocus',
  'color',
  'disabled',
  'flex',
  'rounded',
  'hoverable',
  'loading',
  'checking',
  'checked',
  'size',
  'variant'
]);

